import {
  Stack,
  Text,
  Card,
  IconSearch,
  Box,
  ButtonLink,
} from 'braid-design-system';
import React from 'react';

import CustomSvg from 'src/components/CustomSvg/CustomSvg';
import { getConfigValues } from 'src/config';
import FloatingHeartSvg from 'src/images/floating-heart.svg';

const NoResultsPanel = () => (
  <Card>
    <Box paddingY="large">
      <Stack space="small" align="center">
        <CustomSvg svg={FloatingHeartSvg} width={45} height={57} />

        <Box id="saved-businesses-no-results-heading">
          <Text size="large" tone="secondary" align="center">
            Looks like you don&apos;t have any saved businesses yet
          </Text>
        </Box>

        <Box id="saved-businesses-no-results-text">
          <Text size="large" tone="secondary">
            Let&apos;s get busy!
          </Text>
        </Box>

        <Box paddingTop="medium">
          <ButtonLink
            id="saved-businesses-no-results-btn"
            variant="ghost"
            href={`${getConfigValues().HEADER_SERVER_BASE}/businesses-for-sale`}
            icon={<IconSearch />}
          >
            Search for businesses
          </ButtonLink>
        </Box>
      </Stack>
    </Box>
  </Card>
);

export default NoResultsPanel;
